import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { Provider } from 'react-redux'
import { Switch, Route, Redirect, BrowserRouter } from 'react-router-dom'
import Initializer from './initializer'
import Analysis from '../containers/analysis'
import Maintenence from '../containers/home/maintenance'


import { MainSlate } from '../constants/slates'

import './app.css'

const maintenance = false

const App = ({ store }) => (
  <Provider store={store}>
    <Initializer>
    <BrowserRouter>
      <div id="router-root">
        <Helmet>
          <title>DFSForecast</title>
        </Helmet>
          <div id="scroll-root">
              {
                maintenance ? (
                  <Switch>
                    <Route exact path="*" component={Maintenence} />
                  </Switch>
                ) : (
                  <Switch>
                    <Route exact path="/" render={() => {
                      const searchParams = new URLSearchParams(window.location.search)
                      let queryString = ''
                      for (const [key, value] of searchParams.entries()) {
                        // don't include slate info
                        if (key !== 'date' && key !== 'season') {
                          queryString += `${key}=${value}&`
                        }
                      }
                      return <Redirect to={`/analysis/nba/dk/${MainSlate}/on-off?${queryString}`} />
                    }} />
                    <Route exact path="/analysis/:sport/:site/:slate/:type" component={Analysis} />
                  </Switch>
                )
              }
          </div>
      </div>
    </BrowserRouter>
  </Initializer>
  </Provider>
)

App.propTypes = {
  // State
  store: PropTypes.shape({}).isRequired,

  // Testing
  testElement: PropTypes.element
}

App.defaultProps = {
  // Testing
  testElement: null
}

export default App
